import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import {
    Typography,
    Dialog,
    useMediaQuery,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Box, useTheme,
    Stack
} from '@mui/material'

import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Brightness1Rounded from '@mui/icons-material/Brightness1Rounded';
import BiometricosImg from '../../assets/Biometricos.gif'
import loadingVideo from '../../assets/loadingVideo.mp4'
import loadingVideo_br from '../../assets/loadingVideo_br.gif'

//Custom components
import { UseImage, CustomLoadingOverlay, GenericContainer, Buttons } from '../../components'

import { useStyles } from './BioResultsStyles'
import { coreFunctions } from '../../utils'
import { biometricActions, fileActions, addTitleLegoCurrent, workflowActions } from '../../store/actions';
import { useTranslation } from 'react-i18next';

export default function BioResultsComponent(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const gridContainer = {} //mainStyles.gridStyle()
    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()

    const [loadView, setLoadView] = useState(false)
    const [loadInit, setLoadInit] = useState(false)
    const [seeResults, setSeeResults] = useState(false)
    const [open, setOpen] = useState(false);
    const [bioResItems, setBioResItems] = useState({})
    const [fileId, setFileId] = useState('')
    const [wfcontinue, setwfcontinue] = useState(false)
    const [stageProps, setStageProps] = useState(0)
    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [stageActual, setStageActual] = useState(false)
    const [loadBiometricsResult, setLoadBiometricsResult] = useState(false)
    const [timerSeconds, setTimerSeconds] = useState(-1);
    const { t, i18n } = useTranslation();
    const lang = i18n.language || "es";

    const [uploadingVideo, setUploadingVideo] = useState(true)
    // const [statusValidationErrors, setStatusValidationErrors] = useState(false);
    const [statusUploadVideo, setStatusUploadVideo] = useState(null);

    const actorId = location.state.actorId

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const file = useSelector(state => state.FileInfo)
    const bioRes = useSelector(state => state.BioResult)
    const wf = useSelector(state => state.Workflow)
    // const file = useSelector((state) => state.FileInfo);

    const continueWF = useSelector(state => state.ContinueWorkflow)

    const UploadVideoEvidenceContentJsonResult = useSelector(state => state.UploadVideoEvidenceContentJsonResult)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(addTitleLegoCurrent(t("video_evidency_result_title")))
        setStageActual(location.state.stage)
        setFileId(location.state.folioId)
        // dispatch(fileActions.GetFileInfo({}, true));
        dispatch(fileActions.GetFileInfo(location.state.folioId));
        setLoadInit(true)
    }, []);

    useEffect(() => {
        if (timerSeconds == 0) {
            //Realiza la peticion
            const data = {
                File_Id: fileId,
                Actor_Id: actorId,
                ContinueWorkflow: wfcontinue
            }
            dispatch(biometricActions.GetBiometricResults(data))

            setTimerSeconds(15)
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);

    /*  useEffect(() => {
         console.log('TOMATUDESE', file.items, file, file.items?.Status)
         if (file.items != null && file.items?.Status == "EvidenciasValidacion") {
             setLoadView(false)
             setUploadingVideo(false)
             const data = {
                 File_Id: fileId,
                 Actor_Id: actorId,
                 ContinueWorkflow: true
             }
             dispatch(biometricActions.GetBiometricResults(data))
             setTimerSeconds(15);
             console.log('TOMATUDESE')
         }
 
     }, [file.items]); */

    useEffect(() => {
        console.log('UploadVideoEvidenceContentJsonResult::: ', UploadVideoEvidenceContentJsonResult)

        if ((UploadVideoEvidenceContentJsonResult.items !== undefined
            && UploadVideoEvidenceContentJsonResult.items !== null
            && UploadVideoEvidenceContentJsonResult.items !== "")
            && UploadVideoEvidenceContentJsonResult.loading === false) {
                sessionStorage.setItem('videoUploaded', true)
            if (UploadVideoEvidenceContentJsonResult.items.ResponseCode === 0 && UploadVideoEvidenceContentJsonResult.items.Response !== null) {
                console.log('ENTROAQUI 0')
                // setUploadingVideo(false);
                // dispatch(fileActions.GetFileInfo(location.state.folioId));
                setStatusUploadVideo(true);

            } else if (UploadVideoEvidenceContentJsonResult.items?.ResponseCode !== 0 &&
                (UploadVideoEvidenceContentJsonResult.items.Message !== undefined && UploadVideoEvidenceContentJsonResult.items.Message !== null && UploadVideoEvidenceContentJsonResult.items.Message !== "")) {
                console.log('ENTROAQUI 1')
                // setUploadingVideo(false);
                setStatusUploadVideo(true);
                // setStatusValidationErrors(true);
            }
        } else if (UploadVideoEvidenceContentJsonResult.error != undefined) {
            /* Alert({
                icon: 'error',
                title: "Error al cargar video, por favor vuelve a intentarlo ",
                allowOutsideClick: false,
                allowEscapeKey: false
            }, () => {

            }); */
            setStatusUploadVideo(false);
        }
    }, [UploadVideoEvidenceContentJsonResult])

    const handleUploadSuccess = () => {//Execute GetBiometrics functionality
        setLoadView(true)
        if (statusUploadVideo === true) {
            let dataRequest = {
                File_Id: fileId,
                Stage_Id: file.items?.Stage?.Id
            }
            dispatch(workflowActions.ContinueWorkflowAction(dataRequest))
            setLoadView(true)
        } else {//Return to videorecording
            handleNextLego()
        }
    }

    const handleNextLego = () => {
        let stageName = file.items.Stage.Name
        let stageId = file.items.Stage.Id
        let stage = file.items
        let folioId = file.items.Id
        let nextComponent = coreFunctions.GetLegoNext(stageName)
        console.log("FILEINFO: SAVE video---------------Continue-------------------------:  ", file.items, nextComponent)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
    }

    // console.log('ALL DATA: CWF: ', continueWF, "FILE: ", file, "Status video: ",statusUploadVideo, "uploadingVideo: ",uploadingVideo, "fileId: ", fileId)

    useEffect(() => {//SE TIRA PORQUE YA TRAE DATOS EN CONTINUEWF
        console.log('continueWF:::', continueWF,file)
        if (continueWF.items != undefined /* || file.items?.Status === "EvidenciasValidacion" */) {
            console.log('continueWF::: 0', continueWF)
            setLoadView(false)
            setUploadingVideo(false)
            const data = {
                File_Id: fileId,
                Actor_Id: actorId,
                ContinueWorkflow: true
            }
            dispatch(biometricActions.GetBiometricResults(data))
            setTimerSeconds(15);
        } else if (continueWF.error != undefined) {
            setLoadView(false)
        }
    }, [continueWF])
// console.log('UploadVideoEvidenceContentJsonResult:::',UploadVideoEvidenceContentJsonResult)

    console.log('Video uploaded:' , sessionStorage.getItem("videoUploaded"))
    useEffect(() => {
        setLoadView(file.loading)
        if(file?.items){//No load and return to video evidence
            console.log('ENTRO XD',file?.items,!UploadVideoEvidenceContentJsonResult?.loading)
            if(file?.items?.WorkFlow?.WorkflowInstance?.CurrentStatus === "Completo" && file?.items?.StageName === "EvidenciasValidacion"){
                // sessionStorage.removeItem("videoUploaded")
                setUploadingVideo(false)
                setNextStage()
                sessionStorage.removeItem("videoUploaded")
            } else if( uploadingVideo && file?.items?.WorkFlow?.WorkflowInstance?.CurrentResult === "Video cargado"/* sessionStorage.getItem("videoUploaded") *//* file?.items?.WorkFlow?.WorkflowInstance?.CurrentStatus === "Inicializado" && file?.items?.StageName === "Evidencias" && Object.entries(UploadVideoEvidenceContentJsonResult).length === 0 */){
                console.log('Aqui')
                // setUploadingVideo(false)
                setStatusUploadVideo(true);
                // sessionStorage.removeItem("videoUploaded")
                // setNextStage()
                // handleNextLego()
            }
            // sessionStorage.removeItem("videoUploaded")
        }
    }, [file])

    const setNextStage = () => {
        setLoadView(true)
        setwfcontinue(true)
    }

    useEffect(() => {
        if (wfcontinue) {
            const data = {
                File_Id: fileId,
                Actor_Id: actorId,
                ContinueWorkflow: wfcontinue
            }
            dispatch(biometricActions.GetBiometricResults(data))
            setLoadBiometricsResult(true)
        }
    }, [wfcontinue])

    useEffect(() => {
        setLoadView(bioRes.loading)
        if (bioRes.items != undefined && bioRes.items?.StageStatus == "Completo") {
            if (bioRes.items.StageResult == "Reintento" && loadBiometricsResult) {
                setLoadBiometricsResult(false)
                let stageName = "Evidencias"
                let stageId = stageActual.Id
                let stage = stageActual
                let folioId = fileId
                let nextComponent = coreFunctions.GetLegoNext(stageName)

                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
            }
            else if (bioRes.items.NextStage === null) {
                setSeeResults(true)
                setBioResItems(bioRes.items)
                setLoadView(false)
            } else if (bioRes.items.NextStage != null && wfcontinue) {
                let stageName = bioRes.items.NextStage.Name
                let stageId = bioRes.items.NextStage.Id
                let stage = bioRes.items.NextStage
                let folioId = fileId
                let nextComponent = coreFunctions.GetLegoNext(stageName)

                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
            }
        } else if (bioRes.error != undefined && wfcontinue) {
            // alert(bioRes.error)
            console.log("bioRes.error: ", bioRes.error)
        }
    }, [bioRes])

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (<GenericContainer>

        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}

        {uploadingVideo &&
            <>
                {seeResults ? null :
                    <Box sx={{ maxWidth: '100p%' }} className={localStyles.bioLoading}>
                        {/* <Box sx={{ width: "100%" }}> */}
                        {lang === "pt" ? (
                            <UseImage style={{height: 320}} src={loadingVideo_br} />
                            ) : (
                            <video
                                width={"300vw"}
                                className="loadingVideo"
                                src={loadingVideo}
                                autoPlay
                                loop
                                muted
                            />
                        )}
                        {/* </Box> */}
                    </Box>
                }
                <Box>
                    {/* <Dialog fullScreen open={open} onClose={handleClose} className={matches && gridContainer.container}>
                        <div className={gridContainer.centerColumn}>
                            <CloseIcon className={localStyles.close} onClick={handleClose} />
                            <div className={localStyles.modal}>
                                <Typography variant="body1" gutterBottom
                                >Estatus de resultado</Typography>
                                <Typography variant="subtitle1"
                                    gutterBottom
                                    className={localStyles.stageSubTitle}>
                                    <CheckCircleIcon className={localStyles.helpIconGreen1} />
                                    Verificación cumple con el porcentaje de similitud.
                                </Typography>
                                <Typography variant="subtitle1"
                                    gutterBottom
                                    className={localStyles.stageSubTitle}>
                                    <CancelIcon className={localStyles.helpIconRed1} />
                                    El porcentaje de similitud no cumple con los parámetros mínimos.
                                </Typography>
                            </div>
                        </div>
                    </Dialog> */}

                    <Stack sx={{ display: "flex", flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant='h5'>{statusUploadVideo === true ? t("bio_video_loaded") : t("bio_video_loading")}</Typography>
                        </Box>
                        <Box sx={{ p: 2 }}>
                            {/* <Typography>Estamos cargando tu videograbacion</Typography> */}
                            {statusUploadVideo == true ?
                                <Box sx={{ display: 'flex', my: 2, ml: 0, alignItems: 'center', justifyContent: 'center' }}>
                                    <CheckCircleIcon sx={{ fontSize: 25, mr: 1, color: 'green' }} />
                                    <Typography align="center" sx={{ fontWeight: 350 }}>
                                        {t("bio_video_saved")}
                                    </Typography>
                                </Box>
                                : <>{/* <Box sx={{ display: 'flex', mt: 2, ml: 3, alignItems: 'center' }}>
                                    <CheckCircleIcon sx={{ fontSize: 32, mr: 1.7, color: '#FBBF28' }} />
                                    <Typography variant="h6" align="justify" sx={{ fontWeight: 450 }}>
                                        Video guardado
                                    </Typography>
                                </Box> */}</>}
                            {statusUploadVideo != true && <Typography sx={{ mt: 6 }}>{t("bio_video_wait_message")}</Typography>}
                        </Box>
                        {uploadingVideo && statusUploadVideo !== null &&
                            <Box>
                                <Buttons ConfirmButtonText={statusUploadVideo ? t("general_next_2") : t("applicant_request_retry")}
                                    onClickConfirm={handleUploadSuccess} />
                            </Box>}

                    </Stack>
                </Box>
            </>
        }

        {!uploadingVideo && <>

            {seeResults ? null :
                <div className={localStyles.bioLoading}>
                    <UseImage src={BiometricosImg} className={localStyles.topImage} />
                </div>
            }
            <Box>
                {seeResults ? null :
                    <>
                        {/* <Typography variant="h6"
                        gutterBottom
                        
          >Verificación biométrica</Typography> */}
                        <Typography variant="subtitle1"
                            gutterBottom
                        >
                            {t("bio_confirming_video")}
                        </Typography>
                        <Table className={localStyles.table}>
                            <TableBody>
                                {bioResItems.FacialResult === null ? null :
                                    <TableRow>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.FacialResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : !bioResItems.FacialResult ?
                                                    <Brightness1Rounded style={{ color: theme.palette.success.main }} />
                                                    : ''
                                            }
                                        </TableCell>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_facial_result")}</TableCell>
                                    </TableRow>
                                }
                                {bioResItems.ConsentResult === null ? null :
                                    <TableRow>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.ConsentResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : !bioResItems.ConsentResult ?
                                                    <Brightness1Rounded style={{ color: theme.palette.success.main }} />
                                                    : ''
                                            }
                                        </TableCell>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_result_approved")}</TableCell>
                                    </TableRow>
                                }
                                {bioResItems.EvidenceResult === null ? null :
                                    <TableRow>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.EvidenceResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : <Brightness1Rounded style={{ color: theme.palette.success.main }} />
                                            }
                                        </TableCell>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_result_validation")}</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </>
                }
                {!seeResults ? null :
                    <>
                        {/* <Typography variant="body1" gutterBottom 
          >
                        Resultados de verificación biométrica 
                         <HelpIcon style={{ marginLeft: 7 }} 
                         onClick={handleClickOpen} /></Typography> */}
                        <Dialog fullScreen open={open} onClose={handleClose} className={matches && gridContainer.container}>
                            <div className={gridContainer.centerColumn}>
                                <CloseIcon className={localStyles.close} onClick={handleClose} />
                                <div className={localStyles.modal}>
                                    <Typography variant="body1" gutterBottom
                                    >{t("bio_result_status")}</Typography>
                                    <Typography variant="subtitle1"
                                        gutterBottom
                                        className={localStyles.stageSubTitle}>
                                        <CheckCircleIcon className={localStyles.helpIconGreen1} />
                                        {t("bio_similarity_percentage_meets")}
                                    </Typography>
                                    <Typography variant="subtitle1"
                                        gutterBottom
                                        className={localStyles.stageSubTitle}>
                                        <CancelIcon className={localStyles.helpIconRed1} />
                                        {t("bio_similarity_percentage_not_meets")}
                                    </Typography>
                                </div>
                            </div>
                        </Dialog>

                        <Table className={localStyles.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{
                                        borderBottom: "none",
                                        paddingBottom: 10,
                                    }} padding="none"><b>{t("applicant_biometrics")}</b></TableCell>
                                    <TableCell align="center" style={{
                                        borderBottom: "none",
                                        paddingBottom: 10,
                                    }} padding="none"><b>{t("applicant_results")}</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bioResItems.FacialResult === null ? null :
                                    <TableRow>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_facial_result")}</TableCell>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.FacialResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : !bioResItems.FacialResult ?
                                                    <CancelIcon style={{ color: "red" }} />
                                                    : ''
                                            }
                                        </TableCell>
                                    </TableRow>
                                }
                                {bioResItems.ConsentResult === null ? null :
                                    <TableRow>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_result_approved")}</TableCell>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.ConsentResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : !bioResItems.ConsentResult ?
                                                    <CancelIcon style={{ color: "red" }} />
                                                    : ''
                                            }
                                        </TableCell>
                                    </TableRow>
                                }
                                {bioResItems.EvidenceResult === null ? null :
                                    <TableRow>
                                        <TableCell align="left" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">{t("applicant_result_validation")}</TableCell>
                                        <TableCell align="center" style={{
                                            borderBottom: "none",
                                            paddingBottom: 10,
                                        }} padding="none">
                                            {bioResItems.EvidenceResult ?
                                                <CheckCircleIcon style={{ color: theme.palette.success.main }} />
                                                : <CancelIcon style={{ color: "red" }} />
                                            }
                                        </TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </>
                }
            </Box>
            {!seeResults ? null :
                <Buttons ConfirmButtonText={bioResItems.StageResult != 'Reintento' ? 'Continuar' : t("applicant_request_retry")}
                    onClickConfirm={setNextStage} />
            }
        </>}
    </GenericContainer>)
}